import { Grid } from "@mui/material";
import React from "react";
import { KeyDriveBodyMax } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeyDriveBodyMin } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDrivePrimaryButton } from "../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";

const ErrorPage = (props: any) => {

    return (
        <Grid 
            container
            display="flex"
            flexDirection="column"
        >
            <Grid item>
                <KeyDriveBodyMax 
                    color="#000"
                    needBold={false}
                    needEllipses={false}
                    text="Um erro inesperado aconteceu."
                />
            </Grid>
            <Grid item>
                <KeyDriveBodyMin 
                    color="#000"
                    needBold={false}
                    needEllipses={false}
                    text="Um erro ocorreu ao tentar processar sua solicitação. Tente novamente mais tarde, se o problema persistir contacte o suporte."
                />
            </Grid>
            <Grid item>
                <KeyDrivePrimaryButton 
                    TextComponent={KeyDriveBodyMin}
                    TextComponentProps={{
                        color: "#000",
                        needBold: false,
                        needEllipses: false,
                        text: "Voltar"
                    }}
                    needFullWidth
                />
            </Grid>
        </Grid>
    );
}

export default ErrorPage;